/**
 * CitrusDoctorPage - Citrus Tree Doctor Demo Page
 * 
 * Why this matters: Provides a standalone page for the AI-powered plant diagnosis tool.
 * Designed to be embedded on Shopify or used as a dedicated landing page.
 */

import React from 'react';
import { CitrusDoctor } from '../components/CitrusDoctor';

/**
 * API endpoint configuration
 * Why this matters: Uses environment variable for production, falls back to localhost for dev
 */
const API_ENDPOINT = process.env.REACT_APP_CITRUS_DOCTOR_API_URL || 
  (process.env.NODE_ENV === 'development' 
    ? 'http://localhost:3005/api/citrus-doctor' 
    : '/api/citrus-doctor');

const CitrusDoctorPage: React.FC = () => {
  const handleDiagnosisComplete = (data: any) => {
    // In production, this could trigger analytics, redirect, etc.
    if (process.env.NODE_ENV === 'development') {
      console.log('Diagnosis completed!', data);
    }
  };

  return (
    <CitrusDoctor
      apiEndpoint={API_ENDPOINT}
      onComplete={handleDiagnosisComplete}
    />
  );
};

export default CitrusDoctorPage;
